// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_a3-0";
export var optionCard = "_a3-1";